import React from 'react'
import { artist, iframe } from '../type'
import Iframe from './Iframe';

type Props = {
    className?: string;
} & artist


function Artist({ className, name, imgPath, comment, link }: Props) {
    const iframes: iframe[] = [
        { artist: "Thinking", source: "https://www.youtube.com/embed/KVxbwDc7FEs" },
        { artist: "うたのわ", source: "https://www.youtube.com/embed/GGtc2dC7-DM" },
        { artist: "A-band", source: "https://www.youtube.com/embed/2_AUAmPdLVs" }
    ]

    return (
        <div className={className + ' flex flex-col'}>
            <h2 className='text-3xl font-bold my-1'>{name}</h2>
            {imgPath ?
                <div className='w-full relative pt-[70%] my-1'>
                    <img className='absolute top-0  w-full h-full object-cover' src={process.env.PUBLIC_URL + "/images/2023/gallery/" + imgPath} alt={name} />
                </div> : null
            }
            <p className='my-2'>{comment}</p>
            {iframes.map((item) => {
                return (
                    name === item.artist ?
                        <div className='relative w-full pt-[56.25%] mt-auto'>
                            <Iframe source={item.source} />
                        </div> : null)
            })}
        </div>
    )
}

export default Artist